// A small pill radiogroup: one active option, set on click.
export function Segment({ options, value, onChange, ariaLabel }) {
  return (
    <div className="qk-ai-settings-seg shrink-0" role="radiogroup" aria-label={ariaLabel}>
      {options.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          type="button"
          role="radio"
          aria-checked={value === id}
          className={value === id ? "is-active" : ""}
          onClick={() => onChange(id)}
        >
          {Icon && <Icon />}
          {label ?? id}
        </button>
      ))}
    </div>
  );
}
